// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-B":"NA_outdoor-recreation-B__zuJ_Z","CircleProgress":"NA_CircleProgress__R6_i8"};